import { LeaveOfAbsenceResource, LoketBalancesViewModel, PayrollPeriod } from '@/models'
import {
    ABSENCES_FAILURE,
    ABSENCES_GET_CURRENT_PAYROLL_PERIOD_FAILURE,
    ABSENCES_GET_CURRENT_PAYROLL_PERIOD_SUCCESS,
    ABSENCES_GET_EMPLOYEE_LOKET_BALANCES_REQUEST,
    ABSENCES_GET_EMPLOYEE_LOKET_BALANCES_SUCCESS,
    ABSENCES_REQUEST,
    APP_LOGOUT,
    LEAVE_OF_ABSENCES_FAILURE,
    LEAVE_OF_ABSENCES_REQUEST,
    LEAVE_OF_ABSENCES_SUCCESS,
} from '@/redux/actionTypes'

export interface AbsencesState {
    leaveOfAbsences: LeaveOfAbsenceResource[]
    loading: boolean
    errors?: unknown[]
    employeeBalanceValues: null
    employeeLoketLeaveBalance: LoketBalancesViewModel | null
    currentPayrollPeriod: PayrollPeriod | null
}

export type AbsencesAction =
    | { type: typeof LEAVE_OF_ABSENCES_REQUEST | typeof ABSENCES_REQUEST | typeof ABSENCES_GET_EMPLOYEE_LOKET_BALANCES_REQUEST }
    | { type: typeof LEAVE_OF_ABSENCES_SUCCESS, leaveOfAbsences: LeaveOfAbsenceResource[] }
    | { type: typeof ABSENCES_GET_CURRENT_PAYROLL_PERIOD_SUCCESS, currentPayrollPeriod: PayrollPeriod }
    | { type: typeof ABSENCES_GET_EMPLOYEE_LOKET_BALANCES_SUCCESS, loketLeaveBalance: LoketBalancesViewModel }
    | { type: typeof ABSENCES_GET_CURRENT_PAYROLL_PERIOD_FAILURE | typeof LEAVE_OF_ABSENCES_FAILURE | typeof ABSENCES_FAILURE, errors?: unknown[] }
    | { type: typeof APP_LOGOUT }

const initialState: AbsencesState = {
    leaveOfAbsences: [],
    loading: false,
    errors: [],
    employeeBalanceValues: null,
    employeeLoketLeaveBalance: null,
    currentPayrollPeriod: null,
}

export const absencesReducer = (state: AbsencesState = initialState, action: AbsencesAction): AbsencesState => {
    switch (action.type) {
        case LEAVE_OF_ABSENCES_REQUEST:
        case ABSENCES_REQUEST:
        case ABSENCES_GET_EMPLOYEE_LOKET_BALANCES_REQUEST:
            return { ...state, loading: true }
        case LEAVE_OF_ABSENCES_SUCCESS:
            return {
                ...state, loading: false, leaveOfAbsences: action.leaveOfAbsences,
            }
        case ABSENCES_GET_CURRENT_PAYROLL_PERIOD_SUCCESS:
            return {
                ...state, currentPayrollPeriod: action.currentPayrollPeriod,
            }
        case ABSENCES_GET_EMPLOYEE_LOKET_BALANCES_SUCCESS:
            return {
                ...state, employeeLoketLeaveBalance: action.loketLeaveBalance, loading: false,
            }
        case ABSENCES_GET_CURRENT_PAYROLL_PERIOD_FAILURE:
        case LEAVE_OF_ABSENCES_FAILURE:
        case ABSENCES_FAILURE:
            return {
                ...state, loading: false, errors: action.errors,
            }
        case APP_LOGOUT:
            return { ...initialState }
        default:
            return state
    }
}
